import React, {FunctionComponent, useState} from 'react';
import {Button, Collapse, Switch} from '@blueprintjs/core';

import './CollapseCard.scss';

interface CollapseCardProps {
  title: string;
  showSwitch?: boolean;
  switchValue?: boolean;
  onSwitchChange?: (value: boolean) => void;
  open?: boolean;
  className?: string;
  children: React.ReactNode;
}

const CollapseCard: FunctionComponent<CollapseCardProps> = ({
  title,
  showSwitch = false,
  switchValue = false,
  onSwitchChange = undefined,
  open = false,
  className = '',
  children,
}: CollapseCardProps) => {
  const [isOpen, setIsOpen] = useState(open);
  const [isChecked, setIsChecked] = useState(switchValue);

  const handleSwitchChange = (event: any) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    onSwitchChange && onSwitchChange(checked);
  }

  return (
    <div className="collapse-card">
      <div className="collapse-card__header">
        <Button
          icon={isOpen ? 'chevron-down' : 'chevron-right'}
          minimal={true}
          onClick={() => setIsOpen(!isOpen)}
          text={title}
        />
        <div className={'divider' + (showSwitch ? ' has-switch' : '')}></div>
        {
          showSwitch &&
          <Switch
            defaultChecked={isChecked}
            onChange={handleSwitchChange}
          />
        }
      </div>
      <Collapse
        isOpen={isOpen}
        keepChildrenMounted={true}
        transitionDuration={0}
      >
        {children}
      </Collapse>
    </div>
  );
};

export default CollapseCard;
